import React from "react";
import { Box, Button } from "@mui/material";

export function StepFooterMobile(props: {
  onBack?: () => void;
  onNext?: () => void;
  backLabel?: string;
  nextLabel?: string;
  disableNext?: boolean;
  hideBack?: boolean;
  nextType?: "button" | "submit";
}) {
  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        p: 2,
        display: "flex",
        gap: 2,
        justifyContent: "space-between",
        zIndex: 10,
      }}
    >
      {props.hideBack ? (
        <Box />
      ) : (
        <Button
          type="button"
          variant="outlined"
          color="error"
          onClick={props.onBack}
          sx={{ minWidth: 130, fontWeight: 700 }}
        >
          {props.backLabel ?? "VOLTAR"}
        </Button>
      )}

      <Button
        type={props.nextType ?? "button"}
        variant="contained"
        color="error"
        onClick={(e) => {
          // Se não for a etapa final (submit), impede que o evento suba para o Formik
          if (props.nextType !== "submit") {
            e.preventDefault();
            props.onNext?.();
          }
        }}
        disabled={props.disableNext}
        sx={{ minWidth: 130, fontWeight: 700, boxShadow: 3 }}
      >
        {props.nextLabel ?? "PRÓXIMO"}
      </Button>
    </Box>
  );
}
